module.exports = __webpack_public_path__ + "media/images/front/icon_movie_ar_a-4258fb296761ea42c1f1a7e327756819.png";